import React from 'react'
import { Link } from 'react-router-dom'

const ButtonOutline = ({navigateUrl,text}) => {
  return (
  
    <Link to={navigateUrl} className="btn btn-outline-primary me-1">
      {text}
    </Link>
   
  )
}

export default ButtonOutline